<div class="admin-header">
  <div>
    <h2>{{ 'admin.dashboard.titre' | traduire }}</h2>
    <p>{{ 'admin.dashboard.connecte' | traduire }} : <strong>{{ username }}</strong></p>
  </div>
  <button (click)="seDeconnecter()">{{ 'admin.dashboard.deconnexion' | traduire }}</button>
</div>

<div class="onglets">
  <button [class.actif]="ongletActif === 'ensemble'" (click)="changerOnglet('ensemble')">📊 {{ 'admin.onglet.ensemble' | traduire }}</button>
  <button [class.actif]="ongletActif === 'evenements'" (click)="changerOnglet('evenements')">🎭 {{ 'admin.onglet.programme' | traduire }}</button>
  <button [class.actif]="ongletActif === 'artistes'" (click)="changerOnglet('artistes')">🎤 {{ 'admin.onglet.artistes' | traduire }}</button>
  <button [class.actif]="ongletActif === 'archives'" (click)="changerOnglet('archives')">🗂 {{ 'admin.onglet.archives' | traduire }}</button>
  <button [class.actif]="ongletActif === 'temoignages'" (click)="changerOnglet('temoignages')">
    💬 {{ 'admin.onglet.temoignages' | traduire }}
    <span class="badge-notif" *ngIf="nombreTemoignagesEnAttente > 0">{{ nombreTemoignagesEnAttente }}</span>
  </button>
  <button [class.actif]="ongletActif === 'reclamations'" (click)="changerOnglet('reclamations')">
    📩 {{ 'admin.onglet.reclamations' | traduire }}
    <span class="badge-notif" *ngIf="nombreReclamationsEnAttente > 0">{{ nombreReclamationsEnAttente }}</span>
  </button>
  <button [class.actif]="ongletActif === 'sondages'" (click)="changerOnglet('sondages')">🗳 {{ 'admin.onglet.sondages' | traduire }}</button>
  <button [class.actif]="ongletActif === 'mediatheque'" (click)="changerOnglet('mediatheque')">🖼 {{ 'admin.onglet.mediatheque' | traduire }}</button>
  <button [class.actif]="ongletActif === 'affiches'" (click)="changerOnglet('affiches')">🖨 {{ 'admin.onglet.affiches' | traduire }}</button>
  <button [class.actif]="ongletActif === 'journal'" (click)="changerOnglet('journal')">📜 {{ 'admin.onglet.journal' | traduire }}</button>
  <button [class.actif]="ongletActif === 'parametres'" (click)="changerOnglet('parametres')">⚙ {{ 'admin.onglet.parametres' | traduire }}</button>
</div>

<div class="contenu-onglet">
  <app-vue-ensemble *ngIf="ongletActif === 'ensemble'"></app-vue-ensemble>
  <app-gestion-evenements *ngIf="ongletActif === 'evenements'"></app-gestion-evenements>
  <app-gestion-artistes *ngIf="ongletActif === 'artistes'"></app-gestion-artistes>
  <app-gestion-archives *ngIf="ongletActif === 'archives'"></app-gestion-archives>
  <app-gestion-temoignages *ngIf="ongletActif === 'temoignages'"></app-gestion-temoignages>
  <app-gestion-reclamations *ngIf="ongletActif === 'reclamations'"></app-gestion-reclamations>
  <app-gestion-sondages *ngIf="ongletActif === 'sondages'"></app-gestion-sondages>
  <app-mediatheque *ngIf="ongletActif === 'mediatheque'"></app-mediatheque>
  <app-generateur-affiche *ngIf="ongletActif === 'affiches'"></app-generateur-affiche>
  <app-journal *ngIf="ongletActif === 'journal'"></app-journal>
  <app-parametres *ngIf="ongletActif === 'parametres'"></app-parametres>
</div>
